import React from "react";
import CustomCard from "../Card";
import RecurrencePieChart from "./components/RecurrencePieChart";

const Recurrence: React.FC = React.memo(() => {
  return (
    <CustomCard heading="CASE /" subHeading="RECURRENCE">
      <RecurrencePieChart />
    </CustomCard>
  );
});

export default Recurrence;
